import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '../../services/user.service';
import { DialogService } from '../../services/dialog.service';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'sd-artist-widget',
    templateUrl: './artist-widget.component.html',
    styleUrls: ['./artist-widget.component.scss']
})

export class ArtistWidgetComponent implements OnInit {

    @Input() data: any;
    artist: any;
    followLoading: Boolean = false;

    constructor(
        public user: UserService,
        public dialog: DialogService,
        private api: ApiService,
        public global: GlobalService
    ) { }

    ngOnInit() {
        // console.log(this.data);
        this.artist = this.data.artist;
    }

    followArtist(task = 'follow') {
        const angularthis = this;
        this.followLoading = true;
        if ( task == 'follow' ) {
            this.artist.is_following = true;
            this.artist.followers_count++;

            if ( this.global.isBrowser ) {
                $('.' + angularthis.user.slug  + '_following').html( (parseInt( $('.' + angularthis.user.slug  + '_following').html() ) + 1).toString() );
            }
        } else {
            this.artist.is_following = false;
            this.artist.followers_count--;

            if ( this.global.isBrowser ) {
                $('.' + angularthis.user.slug  + '_following').html( (parseInt( $('.' + angularthis.user.slug  + '_following').html() ) - 1).toString() );
            }
        }

        this.api.followArtist(this.artist.profile.slug_username, task).subscribe(res => {
            this.followLoading = false;
            // console.log(res);
        },
        (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
                // console.log('Client-side error occured!');
            } else {
                // console.log('Server-side error occured!', err);
            }

            if ( task == 'follow' ) {
                this.artist.is_following = false;
                this.artist.followers_count--;

                if ( this.global.isBrowser ) {
                    $('.' + angularthis.user.slug  + '_following').html( (parseInt( $('.' + angularthis.user.slug  + '_following').html() ) - 1).toString() );
                }
            } else {
                this.artist.is_following = true;
                this.artist.followers_count++;

                if ( this.global.isBrowser ) {
                    $('.' + angularthis.user.slug  + '_following').html( (parseInt( $('.' + angularthis.user.slug  + '_following').html() ) + 1).toString() );
                }
            }
            this.followLoading = false;
        });
    }
}
